import Footer from '../../components/Footer/Footer';
import SideBar from '../../components/SideBar/SideBar';
import NavBar1 from '../../components/Navbar1/NavBar1';
import Banner1 from '../../components/Banner/Banner1';
import Banner2 from '../../components/Banner/Banner2';
import Collection from '../../components/Collection/Collection';

const home = () => {

    return (
        <>
            <NavBar1 />
            <SideBar>
                {/* include childrens in sidebar to push horizontally */}
                <Footer>
                    {/* <Banner1 /> */}
                    <Collection />
                    {/* <Banner2 /> */}
                </Footer >
            </SideBar>

        </>
    )
}

export default home;